import { commandApi } from '../../commandApi';

const MANUAL_JUDGEMENT_SETTING_COMMAND = '2bap:set-use-objective-judgement-for-coverage-setting';

class AssessmentCoverageApi {

  setManualJudgementRespect(settingValue) {
    return commandApi.send(MANUAL_JUDGEMENT_SETTING_COMMAND,  { settingValue });
  }

}

export const assessmentCoverageApi = new AssessmentCoverageApi();
